// TODO: 추후 삭제 예정
export var APPROVAL_PHASE;
(function (APPROVAL_PHASE) {
    APPROVAL_PHASE["\uC798\uBABB\uB41C\uC2B9\uC778\uB2E8\uACC4"] = "\uC798\uBABB\uB41C\uC2B9\uC778\uB2E8\uACC4";
    APPROVAL_PHASE["\uBBF8\uD655\uC778"] = "\uBBF8\uD655\uC778";
    APPROVAL_PHASE["\uD655\uC778"] = "\uD655\uC778";
    APPROVAL_PHASE["\uBBF8\uC2B9\uC778"] = "\uBBF8\uC2B9\uC778";
    APPROVAL_PHASE["\uC2B9\uC778"] = "\uC2B9\uC778";
    APPROVAL_PHASE["\uBC18\uB824"] = "\uBC18\uB824";
    APPROVAL_PHASE["\uC2B9\uC778\uBC18\uB824"] = "\uC2B9\uC778\uBC18\uB824";
    APPROVAL_PHASE["\uD655\uC778\uBC18\uB824"] = "\uD655\uC778\uBC18\uB824";
    APPROVAL_PHASE["\uC218\uC8FC\uC644\uB8CC"] = "\uC218\uC8FC\uC644\uB8CC";
})(APPROVAL_PHASE || (APPROVAL_PHASE = {}));
